import { useNavigation } from '@react-navigation/native';
import React from 'react';

import ContentBlock, { ContentBlockProps } from 'app/components/ContentBlock';
import { hasFAQs } from 'app/services/ProductHelper';
import { tID } from 'app/services/TestHelper';

export type ProductFAQProps = ContentBlockProps;

export default function ProductFAQ(props: ProductFAQProps) {
  const navigation = useNavigation();
  return (
    <ContentBlock
      {...props}
      bodyTestID={tID('FAQSectionSubText')}
      ctaTestID={tID('GoToFAQsButton')}
      precondition={() => hasFAQs(props.productContent)}
      testID={tID('ProductFAQ')}
      titleTestID={tID('FAQSectionHeading')}
      onCTAPress={() => {
        navigation.navigate('Tabs', {
          screen: 'ProductStack',
          params: {
            screen: 'ProductFAQ',
            params: { productId: props.productContent?.key ?? '' },
          },
        });
      }}
    />
  );
}
